import '@babel/polyfill'
import Vue from 'vue'
import { MediaQueries } from 'vue-media-queries'
import SiteFooter from './components/SiteFooter'

const mediaQueries = new MediaQueries()
Vue.use(mediaQueries)

/* eslint-disable no-new */
new Vue({
  el: '#site-footer-app',
  components: {
    SiteFooter
  },
  mediaQueries
})



// WEBPACK FOOTER //
// ./WebResources/vue/letter-jackets/site-footer/main.js